var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('Aboutourservices'),_c('div',{},[_c('Caregiverexclusive'),_c('ServicesInPartnership'),_c('MembershipService')],1),_c('div',{},[_c('ServicesFAQ')],1),_c('div',{staticClass:"bge3ceff-opa rounded-t-5555"},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }